import * as yup from 'yup'

export const schema = yup.object().shape({
  discoveryDescription: yup.string().required(),
  incidentType: yup.string().required(),
  detectionAttachments: yup.mixed().fileUpload({ sizeLimit: 5 }),
})

export default schema
